import React from 'react';
import SearchBar from "../containers/SearchBar";
import {AvailabilityRangeMobile} from '../containers/AvailabilityRange';
import AvailabilityRange from '../containers/AvailabilityRange';
import * as AppDimensions from '../constants/AppDimensions';
import {renderMobile} from "../constants/AppDimensions";

const minWidth = AppDimensions.minWidth;
const maxWidth = AppDimensions.maxWidth;

class AvailabilitySearchComponent extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      width: maxWidth,
    };

    this.updateDimensions = this.updateDimensions.bind(this);
  }

  /**
   * Calculate & Update state of new dimensions
   */
  updateDimensions() {

    if(window.innerWidth > maxWidth) {
      this.setState({width: maxWidth });
    } else if(window.innerWidth < minWidth) {
      this.setState({width: minWidth-100});
    } else {
      let update_width  = window.innerWidth-100;
      this.setState({width: update_width});
    }
  }

  /**
   * Add event listener
   */
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  render() {
    return (
        <div className="availabilitySearch"
             style={{width: !renderMobile ? this.state.width : '100%'}}>
          <SearchBar/>
          {!renderMobile && <AvailabilityRange/>}
          {renderMobile && <AvailabilityRangeMobile/>}
        </div>
    )
  }
}

export default AvailabilitySearchComponent;


// WEBPACK FOOTER //
// ./src/components/AvailabilitySearchComponent.js